module.exports = __webpack_public_path__ + "img/foto_4.6dc6c302.png";